import { render, staticRenderFns } from "./community-picker.vue?vue&type=template&id=5a372d38&lang=html&"
import script from "./community-picker.vue?vue&type=script&lang=js&"
export * from "./community-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports